module.exports = __webpack_public_path__ + "img/farm.c3214bfc.svg";